import {DEFAULT_FIELD_PROPS, FIELD_NAMES} from './consts';
import {StoreState} from '../../App/initialStore';
import {getCurrentState} from '../../shared/ActionsManager/EbayListingsActions/currentState';
import * as _ from 'lodash';
import {createSelector} from 'reselect';

export const getDefaultPropsForPublishToAmazonByFieldName = (fieldName, conditionValue?) => {
  const {required, disabled, ...props} = DEFAULT_FIELD_PROPS[fieldName] as any;
  let behaviorData = {required, disabled, notSupported: undefined};
  if (fieldName === FIELD_NAMES.CONDITION_NOTE && conditionValue !== 'New') {
    // as described in api
    behaviorData.required = true;
  }
  return {
    ...props,
    ...behaviorData,
  };
};

export const getAmazonSellerSites = (sellerId: string) =>
  getCurrentState().accountPage.amazonAccounts[sellerId].marketplaceIds;

export const getAmazonSellerFirstSite = (sellerId: string) => (sellerId ? getAmazonSellerSites(sellerId)[0] : '');

export const getAmazonSellerId = (state: StoreState) => state.routing.location.query.selectedSellerId;

export const getAmazonSites = (state: StoreState) => state.general.amazonSites;

export const getAllAmazonSitesForOptions = createSelector(
  [getAmazonSites],
  amazonSites => {
    const options = [];
    _.forEach(amazonSites, site => {
      options.push({label: `Amazon.${site.domain} (${site.text})`, value: site.siteId});
    });
    return options;
  }
);

export const getSellerSites = _.memoize(sellerId => {
  const allOptions = getAllAmazonSitesForOptions(getCurrentState());
  const options = sellerId
    ? _.filter(allOptions, ({value}) => _.indexOf(getAmazonSellerSites(sellerId), value) !== -1)
    : allOptions;
  return {options, sellerId};
});
